































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import apiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import Sortable from 'sortablejs'
import ExtensionInfoItemModel from '@/models/extension/extensionInfoItemModel'
import ExtensionInfoListModel from '@/models/extension/extensionInfoListModel'
import ExtensionInfoModel from '@/models/extension/extensionInfoModel'

@Component
export default class InfoItemListAdmin extends Vue {
  @Prop(Object) readonly info!: ExtensionInfoListModel

  private async created() {
    var self = this
    this.$nextTick(function() {
      let list = document.querySelector(
        '.' + 'infoitem-list-' + this.info.order
      )
      Sortable.create(list, {
        handle: '.draghandle',
        async onEnd({
          newIndex,
          oldIndex
        }: {
          newIndex: number
          oldIndex: number
        }) {
          const itemSelected = self.info.extensionInfoItems.splice(
            oldIndex,
            1
          )[0]
          self.info.extensionInfoItems.splice(newIndex, 0, itemSelected)
          await self.updateOrder(self.info)
        }
      })
    })
  }

  @Emit()
  private async updateOrder(info: ExtensionInfoListModel) {
    for (let i = 0; i < info.extensionInfoItems.length; i++) {
      let item = info.extensionInfoItems[i]
      item.order = i
    }
    await apiService.put(
      UrlType.ExtensionInfoItemBase + '/order',
      this.info.extensionInfoId,
      this.info
    )
  }

  @Emit()
  private async updateInfo(infoItem: ExtensionInfoItemModel) {
    await apiService.put<ExtensionInfoItemModel>(
      UrlType.ExtensionInfoItemBase,
      infoItem.extensionInfoItemId,
      infoItem
    )
  }

  @Emit()
  private async deleteInfo(infoItem: ExtensionInfoItemModel) {
    if (confirm('Are you sure you want to delete this item?')) {
      await apiService.delete(
        UrlType.ExtensionInfoItemBase,
        infoItem.extensionInfoItemId
      )
    }
  }
}
